import axios from 'axios';
import getAppConfig from '../../config';
import { setGlobalLoader } from '../ui/uiActions';
import { setSnackBarAlert, caughtError } from '../ui/uiActions';
import { getQueryString } from '../../components/common/functions';

import {
  YOUTUBE_LIBRARY_SET_INITIAL_STATE,
  YOUTUBE_LIBRARY_FIND_ALL,
  YOUTUBE_LIBRARY_VIEW
} from './youtubeLibraryTypes';

const config = getAppConfig();

export const viewYoutubeLibrary = (youtubeLibraryId) => {
  let URL = `${config.api.URL}/me/youtube-library/${youtubeLibraryId}`;
  return (dispatch) => {
    dispatch(onSuccessViewYoutubeLibrary({data: false}))
    axios.get(URL).then(response => {
      dispatch(onSuccessViewYoutubeLibrary(response))
    }).catch(error => {
      dispatch(caughtError(error))
    })
  }
}

export const deleteYoutubeLibrary = (youtubeLibraryId, filterInput) => {
  let URL = `${config.api.URL}/me/youtube-library/mark-delete/${youtubeLibraryId}`;
  if(filterInput.deleted === true) {
    // if record already deleted
    URL = `${config.api.URL}/me/youtube-library/unmark-delete/${youtubeLibraryId}`;
  }
  return (dispatch) => {
    axios.patch(URL).then(response => {

      dispatch(setSnackBarAlert({
        openSnackBar: true,
        severity: 'success',
        message: `Success! youtubeLibrary ${filterInput.deleted ? 'restored' : ' moved to trash'}`
      }))

      dispatch(findAllYoutubeLibrarys(filterInput));
    }).catch(error => {
      dispatch(caughtError(error))
    })
  }
}

export const findAllYoutubeLibrarys  = (filters="") => {
  let URL = `${config.api.URL}/me/youtube-library`;
  if(filters !== '') {
    URL = `${URL}?${getQueryString(filters)}`;
  }
  return (dispatch) => {
    dispatch(setGlobalLoader(true))
    axios.get(URL).then(response => {
      dispatch(setGlobalLoader(false))
      dispatch(onSuccessFindAllYoutubeLibrary(response))
    }).catch(error => {
      dispatch(setGlobalLoader(false))
      dispatch(setYoutubeLibraryInitialState())
      dispatch(caughtError(error))
    })
  }
}
export const setYoutubeLibraryInitialState = () => {
  return {
    type: YOUTUBE_LIBRARY_SET_INITIAL_STATE
  }
}

export const onSuccessViewYoutubeLibrary = response => {
  return {
    type: YOUTUBE_LIBRARY_VIEW,
    payload: response.data
  }
}

export const onSuccessFindAllYoutubeLibrary = response => {
  return {
    type: YOUTUBE_LIBRARY_FIND_ALL,
    payload: response.data
  }
}
